<template>
  <div v-if="token.role === 'ADM'">
    <div class="row mt-5">
      <div class="col text-center">
        <h5>Eventos do sistema</h5>
      </div>
    </div>
    <hr>

    <div class="row">
      <div class="col table-responsive">
        <div class="alert alert-warning" role="alert" v-if="data.length === 0">
          Nenhum registro cadastrado.
        </div>


        <form v-on:submit.prevent="setPage(1)" v-if="token.role === 'CA' || token.role === 'ADM'">
          <fieldset>
          <legend>Filtrar</legend>
          
          <div class="form-group">
            <label for="empresa">Empresa</label>
            <select @change="setPage(1)" v-model="empresa" class="form-control" name="empresa" id="empresa">
              <option value="TODAS">TODAS</option>

              <option v-for="empresa in empresas" :key="empresa._id" :value="empresa._id">{{empresa.nome}}</option>
            </select>
          </div>
          </fieldset>
        </form>

        <table class="table table-sm">
          <thead class="thead-light">
            <tr>
              <th scope="col">Data / Hora</th>
              <th scope="col">Modulo / Usuário / Empresa</th>
              <th scope="col">Evento</th>
              <th scope="col">Opções</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="item in data" :key="item._id">
                <td scope="row">{{formata(item.data)}}</td>
                <td scope="row">{{item.modulo}}/{{item.usuario ? item.usuario.login : ''}}/{{item.empresa ? item.empresa.nome : 'CAQUI'}}</td>
                <td scope="row">{{item.evento}}</td>
                <td>
                  <a href="javascript:;" @click.prevent="remove(item._id)" title="Remove">Remover</a>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
      <!-- <div class="col">
          <div class="alert alert-warning" role="alert" v-if="data.length === 0">
            Nenhum registro cadastrado.
          </div>

          <div id="accordion">
            <div class="card" v-for="item in data" :key="item._id">
              <div class="card-header" :id="'H' + item._id" data-toggle="collapse" :data-target="'#D' + item._id" >
                <div class="row">
                  <div class="col">
                    {{item.evento}}
                  </div>
                  <div class="col">
                    <router-link title="Alterar" :to="`${route}/edit/${item._id}`">
                      Alterar
                    </router-link>
                    /
                    <a class="text-danger" @click="remove(item._id)">Excluir</a>
                  </div>
                </div>
              </div>

              <div :id="'D'+item._id" class="collapse" data-parent="#accordion">
                <div class="card-body">

                </div>
              </div>
            </div>
          </div>
      </div> -->
    </div>

    <hr>
    <div class="row" v-if="data.length > 0">
      <div class="col">
          <pagination :records="total" :options='pagOpts' :per-page="perPage" @paginate="setPage">
          </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';

export default {
  data() {
    return {
      data: [],
      empresas: [],
      empresa: 'TODAS',
      route: '/admin/eventos',
      page: 1,
      perPage: 10,
      total: 0,
      pagOpts: this.$custom.pagOpts
    };
  },
  methods: {
    remove(id) {
      this.$http.delete(`${this.route}/${id}`).then(() => {
        this.setPage(this.page);
      });
    },
    setPage: function(page) {
      this.page = page;

      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;
      const empresa = this.empresa;

      let url = `${this.route}/list`;

      this.$http.post(url, { skip, limit, empresa }).then(response => {
        this.data = response.data.data;
        this.total = response.data.total;
      });
    },
    formata(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss');
    }
  },
  beforeMount() {

    this.$http.post('/admin/empresas/list').then(response => {
        this.empresas = response.data.data;
    });

    this.setPage(1);
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/app/admin/eventos/Home.vue